exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-5af08bd2]{width:100%;text-align:center;margin-top:1.36rem;font-size:.28rem}.container img[data-v-5af08bd2]{height:auto;width:1.32rem}.container .msg[data-v-5af08bd2]{font-size:.24rem}.container .title[data-v-5af08bd2]{margin:.2rem 0}.interview_msg[data-v-5af08bd2]{margin:.6rem 0 0}.interview_msg img[data-v-5af08bd2]{width:.98rem;height:auto;vertical-align:bottom;padding-bottom:.09rem}.interview_msg span[data-v-5af08bd2]{font-size:.28rem;color:#323233;margin:0 .28rem}.list[data-v-5af08bd2]{margin-top:.5rem}.list p[data-v-5af08bd2]{width:80%;margin-left:10%;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5af08bd2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/defeat/index.vue
// module id = lJAb
// module chunks = 1